module.exports = __webpack_public_path__ + "img/ROROCCCC01400001.4d657334.png";